import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { countriesList, Country } from './countries-list';
import { NgxMaskDirective } from 'ngx-mask';
import { FormsModule } from '@angular/forms';

export interface Phone {
  mask: string;
  country_code: string
  currentFlag: string
  currentCountryNumber: string
  minPhoneSize: number
  phone?: string;
}

@Component({
  selector: 'app-flag-phone-input',
  imports: [
    CommonModule,
    FormsModule,
    IconComponent,
    NgxMaskDirective,
  ],
  templateUrl: './flag-phone-input.component.html',
  styleUrls: ['./flag-phone-input.component.scss']
})
export class FlagPhoneInputComponent {

  @Input() phone: string;
  @Input() error: boolean = false;

  @Output() phoneChange = new EventEmitter<string>();
  @Output() dataEmitter = new EventEmitter<Phone>();
  @ViewChild('firstInput', { static: false }) firstInput: any;

  selectedCountry: Country;
  countries: Country[] = countriesList;
  active: boolean = false
  ios = false;

  constructor() {
    this.setMask('BR')
    setTimeout(() => {
      if (this.firstInput) {
        this.firstInput.nativeElement.focus()
      }
    }, 400);
  }

  dropdownHandle() {
    this.active = this.active = !this.active
  }

  dataEmmit() {
    this.dataEmitter.emit({
      mask: this.selectedCountry.mask,
      country_code: this.selectedCountry.ddd,
      currentFlag: this.selectedCountry.flag,
      currentCountryNumber: this.selectedCountry.shorthandDdd,
      minPhoneSize: this.selectedCountry.minPhoneSize,
      phone: this.phone
    })
  }

  setMask(shorthand: string) {
    const countryFound = this.countries.find((country: Country) => country.shorthand == shorthand)

    if(countryFound) {
      this.selectedCountry = countryFound;
      this.dataEmmit()
    }

    this.active = false
  }
}
